// Team member dialog wrapper

import { TeamMemberFormData } from '@/client/utils/validationSchemas';
import { TeamForm } from './TeamForm';
import type { TeamMember } from '@/lib/sdk/team/types';
import { Modal } from '@/client/components/shared/Modal';

interface TeamDialogProps {
  isOpen: boolean;
  onClose: () => void;
  initialData?: Partial<TeamMemberFormData>;
  onSubmit: (data: TeamMemberFormData) => Promise<void>;
  title?: string;
  isCurrentUserAdmin?: boolean;
  memberOptions?: TeamMember[];
}

export function TeamDialog({
  isOpen,
  onClose,
  initialData,
  onSubmit,
  title,
  isCurrentUserAdmin = false,
  memberOptions = [],
}: TeamDialogProps) {
  const handleSubmit = async (data: TeamMemberFormData) => {
    await onSubmit(data);
    onClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={title || (initialData ? 'Edit Team Member' : 'Add Team Member')}
      size="lg"
    >
      <TeamForm
        initialData={initialData}
        onSubmit={handleSubmit}
        onCancel={onClose}
        isCurrentUserAdmin={isCurrentUserAdmin}
        memberOptions={memberOptions}
      />
    </Modal>
  );
}
